import { WorkOrderStatusEnum } from 'gql/graphql';

export const useGetTextDialogStatus = (defaultStatus: WorkOrderStatusEnum, selectedStatus: WorkOrderStatusEnum) => {
    const isDefaultStatusOnFormation = defaultStatus === WorkOrderStatusEnum.OnFormation;
    const isDefaultStatusInProgress = defaultStatus === WorkOrderStatusEnum.InProgress;
    const isDefaultStatusDelayed = defaultStatus === WorkOrderStatusEnum.Delayed;
    const isChangedStatusInProgress = selectedStatus === WorkOrderStatusEnum.InProgress;
    const isChangedStatusDelayed = selectedStatus === WorkOrderStatusEnum.Delayed;
    const isChangedStatusCompleted = selectedStatus === WorkOrderStatusEnum.Completed;
    const isChangedStatusOnFormation = selectedStatus === WorkOrderStatusEnum.OnFormation;

    if (isDefaultStatusOnFormation && isChangedStatusInProgress) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «В работе» добавление новых записей в Наряд-Заказе приведёт к созданию
                    изменения к Наряд-Заказу или Доп. соглашения.
                </div>
                <div>Вы уверены, что хотите изменить статус?</div>
            </>
        );
    }

    if (
        (isDefaultStatusOnFormation && isChangedStatusDelayed) ||
        (isDefaultStatusInProgress && isChangedStatusDelayed)
    ) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>Дальнейшая работа по Наряд-Заказу будет недоступна.</div>
                <div>Вы уверены, что хотите изменить статус на «Отложен»?</div>
            </>
        );
    }

    if (isDefaultStatusInProgress && isChangedStatusCompleted) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «Завершён» дальнейшая работа по Наряд-Заказу будет недоступна.
                </div>
                <div>Вы уверены, что хотите изменить статус?</div>
            </>
        );
    }

    if (isDefaultStatusInProgress && isChangedStatusOnFormation) {
        return (
            <div>
                Вы уверены, что хотите изменить статус <br /> на &quot;На формировании&quot;?
            </div>
        );
    }

    if (isDefaultStatusDelayed) {
        return (
            <div>
                Вы уверены, что хотите изменить статус на «
                {selectedStatus === WorkOrderStatusEnum.OnFormation ? 'На формировании' : 'В работе'}»?
            </div>
        );
    }

    return undefined;
};
